// extracted by mini-css-extract-plugin
var _1 = "pdf-viewer__EEQx7";
export { _1 as "pdfViewer" }
